import origin from "axios";
import {
  BASEURL,
  GETSTOREDVISIGTERRECORDS,
  GETVISIGTERRECORDS,
  USERLOGIN,
  USERLOGOUT
} from "./api";
import { collapseClasses } from "@mui/material";

// Create a base axios instance
export const axios = origin.create({
  baseURL: BASEURL,
  headers: {
    "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Add a request interceptor to attach the token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('accessToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Define API methods
export const userLogin = async (formValues) => {
  try {
    const res = await axios.post(`${USERLOGIN}`, formValues, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const userLogOut = async () => {
  try {
    const token = localStorage.getItem("access_token"); // Get token

    const res = await axios.post(`${USERLOGOUT}`, { token }, {  // Send empty body
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

// Visiter API Function Start
// export const getVisiteRecords = async (talukaId = "") => {
//   try {
//     const token = localStorage.getItem("access_token"); // Get token
//     if (!token) throw new Error("No access token found");

//     const endpoint = talukaId ? `${GETVISIGTERRECORDS}/${talukaId}` : `${GETVISIGTERRECORDS}`;

//     const res = await axios.get(endpoint, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     console.log(res, "resresresres");
//     return res.data;
//   } catch (error) {
//     throw error;
//   }
// };


export const getVisiteRecords = async (formdata) => {
  console.log(formdata, "formdataformdataformdata");
  try {
    const token = localStorage.getItem("access_token"); // Get token
    if (!token) throw new Error("No access token found");

    const res = await axios.post(
      `${GETVISIGTERRECORDS}`,
      formdata, // ✅ Send formdata directly
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ Token should be here
        },
      }
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};
export const storeVisiterRecord = async (formdata) => {
  console.log(formdata, "formdataformdataformdata");
  try {
    const token = localStorage.getItem("access_token"); // Get token
    if (!token) throw new Error("No access token found");

    const res = await axios.post(
      `${GETSTOREDVISIGTERRECORDS}`,
      formdata, // ✅ Send formdata directly
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ Token should be here
        },
      }
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};

// Visiter API Function End

